

/**
 * @name ArchiveAppointmentController
 * @description Controller for archiving appointments
 * @param {type} $uibModalInstance Description
 * @param {type} Appointment Description
 * @param {type} appointment Description
 * @param {library} _ The Lodash library
 */
function ArchiveAppointmentController(
  $uibModalInstance,
  Appointment,
  appointment,
  _
) {
  let vm = this;
  vm.appointment = _.cloneDeep(appointment);

  vm.submit = function() {
    let status = 100;

    // Send the Appointment Update
    Appointment.update(vm.appointment, status)
    .then(function(appointment) {
      $uibModalInstance.close(appointment);
    });
  };

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('ArchiveAppointmentController', ArchiveAppointmentController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/archive/archive.controller.js